<template>
	<div>
		<el-dialog
			class="warehouse-modal"
			:before-close="closeModal"
			:visible="openModal"
		>
			<div slot="title">
				<div
					class="modal-title d-flex align-center"
					:style="`background-color:${globalColors.primary}`"
				>
					<el-button
						class="arrow-back"
						icon="el-icon-back"
						@click="goBack"
						v-if="showMap"
					></el-button>
					<h1 class="modal-title-text">{{modalTitle}}</h1>
				</div>
			</div>
			<transition name="go-left" mode="out-in" tag="div">
				<section class="map" v-if="showMap" key="map">
					<p>
						<span><b>{{selectedWarehouse.autocomplete}}: </b></span>
						<span>{{selectedWarehouse.warehouse.address}}</span>
					</p>
					<map-component :location="warehouseLocation"/>
				</section>
				<section class="table" v-else key="warehouse-table">
					<div class="header grid-sistem">
						<span
							v-for="column in columns"
							:key="column.title"
						>{{column.title}}</span>
					</div>
					<div class="body">
						<div
							class="row grid-sistem"
							v-for="(row, indexRow) in rows"
							:key="indexRow"
						>
						<span>
							<span class="warehouse-name">{{row.warehouse.name}}<br></span>
							<span class="warehouse-address">{{row.warehouse.address}}</span>
						</span>
						<span :class="{ 'stock-cero': row.stock === 0 }">{{row.stock}}</span>
						<span
							v-if="warehouseLatLon(row)"
							@click="goToMap(row)"
						>
							<img src="/static/img/icons/map.svg" alt="mapa">
						</span>
						</div>
					</div>
				</section>
			</transition>
		</el-dialog>
	</div>
</template>
<script>

function goToMap(row) {
	this.showMap = true;
	this.selectedWarehouse = row;
	const { warehouse: { location: { x, y } } } = row;
	this.warehouseLocation = { lat: x, lng: y };
}

function goBack() {
	this.showMap = false;
}

function modalTitle() {
	return 'Disponibilidad del producto en tiendas';
}

function closeModal() {
	this.$emit('close-modal');
}

async function loadWarehouse() {
	if (this.openModal) {
		const requests = [
			this.$httpQtc.get(`products-public/${this.id}/stock-by-warehouse`),
		];
		([
			{ data: this.rows },
		] = await Promise.all(requests));
	}
}

function warehouseLatLon(row) {
	const { warehouse: { location } } = row;
	const { x, y } = location || {};
	return (!!x && !!y);
}

function data() {
	return {
		citySelected: '',
		columns: [
			{ title: 'DIRECCIÓN' },
			{ title: 'STOCK' },
			{ title: 'MAPA' },
		],
		rows: [],
		showMap: false,
		options: [
			{ label: 'Lima', value: 'Lima' },
			{ label: 'Ayacucho', value: 'Ayacucho' },
			{ label: 'Cusco', value: 'Cusco' },
		],
		selectedWarehouse: {},
		warehouseLocation: {
			lat: 0,
			lng: 0,
		},
	};
}

export default {
	name: 'warehouse-modal',
	components: {
		mapComponent: () => import('@/components/mapComponent.vue'),
	},
	computed: {
		modalTitle,
	},
	data,
	methods: {
		closeModal,
		goBack,
		goToMap,
		loadWarehouse,
		warehouseLatLon,
	},
	props: {
		openModal: {
			default: false,
			type: Boolean,
		},
		id: {
			type: [Number, String],
		},
	},
	watch: {
		openModal: loadWarehouse,
	},
};
</script>
<style lang="scss" scoped>
	.header {
		background-color: color(grayBold);
		font-weight: bold;
		padding: 1rem;
	}

	.grid-sistem {
		display: grid;
		grid-template-columns: 3fr 1fr 1fr;
		grid-gap: 0.5rem;
	}

	.row {
		border-bottom: 0.1rem solid color(whiteBold);
		padding: 1rem;
	}

	.warehouse-name,
	.warehouse-city {
		font-weight: bold;
	}

	.stock-cero {
		color: color(redBold);
	}

	.arrow-back {
		background-color: transparent;
		border: none;
		color: white;
		font-size: size(mslarge);
	}

	.modal-title {
		padding: 20px;
	}

	.modal-title-text {
		color: white;
		margin: 0;
	}
</style>




// WEBPACK FOOTER //
// warehouseModal.vue?4c69abb2